var getUtag = function () {
    if (typeof window === "undefined") {
        console.warn("@argonaut/analytics function calls should be wrapped in a useEffect hook to prevent them running on the server");
        return Promise.resolve({
            view: function () { return undefined; },
            link: function () { return undefined; },
            data: {},
        });
    }
    return new Promise(function (resolve) {
        return window["@argonaut/analytics/loadTealium"](function () { return resolve(window.utag); });
    });
};
export default getUtag;
//# sourceMappingURL=getUtag.js.map